import React from 'react';
import {Container, Row} from 'react-bootstrap';
import Title from './SectionTitle';
import Item from './GalleryItem';

const ITEMS = [
    { n: 1, alt: "Automobilio transportavimas traliuku Kaune" },
    { n: 2, alt: "Traliukas – pagalba kelyje Lietuvoje" },
    { n: 3, alt: "Sugedusio automobilio pervežimas traliuku" },
    { n: 4, alt: "Avarinė pagalba kelyje – automobilio krovimas į tralą" },
    { n: 5, alt: "Tralo paslaugos Kaune – lengvojo automobilio pervežimas" },
    { n: 6, alt: "Visureigio transportavimas traliuku visoje Lietuvoje" },
    { n: 7, alt: "Mikroautobuso pervežimas geltonu traliuku" },
    { n: 8, alt: "Techninė pagalba kelyje 24/7 – tralo paslaugos" },
    { n: 9, alt: "Saugus ir kokybiškas automobilio pervežimas Lietuvoje" },
];

function Section(prop){
    let scrollOffsetClass = "";
    if (prop.onTop && prop.pageWidth<=990){
        scrollOffsetClass = "scroll-offset-fix";
    }

    return (
        <div id="gallery" className={scrollOffsetClass} style={prop.section==='dark'? {backgroundColor:'#fef5dd'}:null} >
        <Container className="section-padding">
        {!prop.hideTitle && <Title title={prop.strings.gallery.sectionName} />}
            <Row >
                {ITEMS.map(it => (
                    <Item
                        key={it.n}
                        strings={prop.strings}
                        photo={`gallery/image-${it.n}.jpg`}
                        tumb={`gallery/image-${it.n}-thumb.jpg`}
                        alt={it.alt}
                    />
                ))}
            </Row>
        </Container>
        </div>
    )
}

export default Section;
